import cn from '@integrations/classnames'
import { PaymentOptionStatuses, useCurrencies } from 'mmfintech-backend-api'
import { formatMoney, tr } from 'mmfintech-commons'
import styles from './InputAmountLimits.module.scss'

interface Props {
  currency?: string
  paymentOption?: any
}

function InputAmountLimits({ currency, paymentOption }: Props) {
  const { getCurrencyPrecision } = useCurrencies()
  const decimals = getCurrencyPrecision(currency)

  function getLimits() {
    const { available, status, minAmount, maxAmount, maxAmountLimitedByBalance } = paymentOption || {}

    if (available || status === PaymentOptionStatuses.AVAILABLE) {
      const res = []

      if (minAmount > 0) {
        res.push(`${tr('FRONTEND.MONEY_INPUT.LABEL_MIN', 'Min')}: ${formatMoney(minAmount, currency, decimals)}`)
      }
      if (maxAmount > 0) {
        const formattedAmount = formatMoney(maxAmount, currency, decimals)
        const isLimitedByBalance = maxAmountLimitedByBalance ?? (minAmount > 0 ? maxAmount < minAmount : true)
        if (!isLimitedByBalance) {
          res.push(`${tr('FRONTEND.MONEY_INPUT.LABEL_MAX', 'Max')}: ${formattedAmount}`)
        } else {
          res.push(
            `${tr('FRONTEND.MONEY_INPUT.LABEL_MAX_AVAILABLE', 'Max available including fees')}: ${formattedAmount}`
          )
        }
      }

      return res.length > 0 && res.join(', ')
    }

    return null
  }

  return <div className={cn(styles['input-amount-limits'], 'input-amount-limits')}>{getLimits() || ' '}</div>
}

export default InputAmountLimits
